import { render, staticRenderFns } from "./cDocumentSideBySide.vue?vue&type=template&id=b6f9419c&scoped=true"
import script from "./cDocumentSideBySide.vue?vue&type=script&lang=js"
export * from "./cDocumentSideBySide.vue?vue&type=script&lang=js"
import style0 from "./cDocumentSideBySide.vue?vue&type=style&index=0&id=b6f9419c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f9419c",
  null
  
)

export default component.exports